/*
 * Copyright (c) 2020 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {IconProps} from '../types/types';
import useIconDLS from './useIconDLS';

/*
 * Defines the Design Language System (DLS) StarsIcon Icon component.
 */
export const StarsIcon = (props: IconProps) => {
  const {iconSize, iconColor} = useIconDLS(props);
  return (
    <svg width={iconSize} height={iconSize} viewBox='0 0 24 24' fill='none'>
      <path d='M8.30058 9.04113C8.463 9.01538 8.60238 8.9114 8.67334 8.76305L10.9934 3.91282C11.1721 3.53917 11.7016 3.5324 11.8898 3.90136L14.3304 8.68548C14.4052 8.83228 14.5477 8.93274 14.7111 8.95407L20.0345 9.64879C20.4456 9.70243 20.6166 10.2043 20.3238 10.4978L16.5256 14.304C16.4094 14.4205 16.3579 14.5866 16.3879 14.7483L17.3655 20.0242C17.441 20.4316 17.0166 20.7488 16.6472 20.561L11.8642 18.1291C11.7176 18.0545 11.5437 18.0569 11.3991 18.1353L6.6792 20.6973C6.31519 20.8949 5.88255 20.5896 5.9467 20.1805L6.77931 14.8695C6.80479 14.707 6.74872 14.5424 6.62936 14.4293L2.73603 10.7379C2.43515 10.4526 2.59225 9.94611 3.00176 9.88118L8.30058 9.04113Z'
        stroke={iconColor}
        strokeWidth='1.5'
        strokeMiterlimit='10' />
    </svg>
  );
};
